const styles = theme => ({
  collectionToolBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  viewAllText: {
    fontSize: '12px',
    color: '#919EAB',
    fontWeight: 400,
    cursor: 'pointer',
  },
  accessRule: {
    display: 'flex',
    padding: '3px 6px',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
    cursor: 'pointer',
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
})

export default styles
